import '@/firebase';
import 'leaflet/dist/leaflet.css';
import {Icon} from 'leaflet';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vue from 'vue'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as firebase from 'firebase/app';
import LoadScript from 'vue-plugin-load-script'
import {firestorePlugin} from 'vuefire'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import './validation-rules'
import {library} from '@fortawesome/fontawesome-svg-core'
// import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faPlusCircle, faUserCheck, faPencilAlt, faTimesCircle, faArrowLeft} from "@fortawesome/free-solid-svg-icons";

// library.add(faPlusCircle, faUserCheck, faPencilAlt, faTimesCircle,faArrowLeft)

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(firestorePlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(LoadScript)

Sentry.init({
  dsn: 'https://df0f438907ed4721859bcfa6c18705fc@o383630.ingest.sentry.io/5213900',
  integrations: [new VueIntegration({Vue, attachProps: true})],
});

let appStarted: boolean = false

firebase.auth().onAuthStateChanged((user) => {
    if (user) {
        store.dispatch('autoSignIn', user)
    }
    if (!appStarted) {
        new Vue({
            router,
            store,
            render: h => h(App),
            created() {
                appStarted = true
                if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
                    let email = window.localStorage.getItem('emailForSignIn');
                    if (!email) {
                        email = window.prompt('Please provide your email for confirmation');
                    }
                    this.$store.dispatch('signInWithEmailLink', {email})
                }
            }
        }).$mount('#app')
    }

})
